/* eslint-disable max-lines */
// internal-deps
import { PaymentAlertProps, DirectPlaceOrderPayload, PaymentToastProps } from "@swiggy-private/payment-types";

// interfaces
import {
    PollPennyTransactionStatusActionPayload,
    ProcessOrderActionPayload,
    ProcessTransactionActionPayload,
    ConfirmTransactionActionPayload,
    ConfirmOrderActionPayload,
    FailedOrderActionPayload,
    OrderInterruptionAlertPayload,
    VpaTimerActionPayload,
    InvalidCouponAlertPayload,
    UpiIntentPollerActionPayload,
    FailedTransactionActionPayload,
    PayOnDeliveryPaymentAlreadyDoneActionPayload,
    AutoPayFailedOrderActionPayload,
    PayLaterSimplActionFailurePayload,
    PayLaterSimplActionSuccessPayload,
    ShowPaymentsPayload,
    CartRendererActionPayload,
    CouponListingActionPayload,
    SharedCartPayload,
    UnlockGroupCartActionPayload,
    DineoutCartRendererActionPayload,
    DineoutSuccessActionPayload,
    WebviewRefreshOrderIdMismatchAlertPayload,
} from "@checkout-core/interfaces/Checkout";

export type CheckoutState = CheckoutAction;
export enum CheckoutActionTypes {
    SHOW_PAYMENTS,
    SHOW_CART,
    PROCESS_ORDER,
    VPA_TIMER,
    CONFIRM_ORDER,
    PAYMENT_FAILED,
    ORDER_INTERRUPTION,
    SHOW_FULL_PAGE_LOADER,
    ADD_MONEY_CONFIRM,
    INVALID_COUPON_ALERT,
    DIRECT_PLACE_ORDER,
    PAYMENT_TXN_STATUS_POLLER,
    POST_SWIGGY_ADD_MONEY,
    POST_PAYLATER_LINKING,
    SHOW_SWIGGYMONEY_PAYMENTS,
    ADD_SWIGGY_MONEY,
    ADD_NEW_CARD,
    MANAGE_CARD,
    SECURE_CARD,
    PROCESS_TRANSACTION,
    CONFIRM_TRANSACTION,
    PENNY_TXN_STATUS_POLLER,
    TRANSACTION_FAILED,
    GENERIC_PAYMENT_ALERT,
    PAY_ON_DELIVERY_PAYMENT_ALREADY_DONE,
    AUTOPAY_ELIGIBLE_PAYMENT_FAILED,
    AUTOPAY_ORDER_PROCESS_SUCCESSFUL,
    LINK_WALLET_WITH_NUMBER,
    ADD_MONEY_AND_DELINK_WALLET,
    PAYLATER_LINKING_CONFIRMATION,
    SHOW_PAYMENT_MODES,
    TURBO_PAY,
    TURBO_PLACE_ORDER,
    SHOW_COUPON_LISTING,
    PAYLATER_SIMPL_LINKING_FAILED,
    PAYLATER_SIMPL_LINKING_SUCCESS_DONT_PROCEED_WITH_ORDER,
    PAYLATER_SIMPL_LINKING_SUCCESS_PROCEED_WITH_ORDER,
    DINEOUT_PAYMENT_SUCCESS,
    DINEOUT,
    SHARED_CART,
    GENERIC_PAYMENT_TOAST,
    UNLOCK_GROUP_CART,
    EMI_SELECTION,

    //Dineout
    DINEOUT_BILL_PAYMENT_CART,
    DINEOUT_TABLE_RESERVATION_CART,
    DINEOUT_DIRECT_PLACE_ORDER,
    SCENES_FULL_PAYMENT,
    STEAL_STORE_CART,

    //webview refresh order id mismatch alert
    WEBVIEW_REFRESH_ORDER_ID_MISMATCH_ALERT,

    // Gifting
    SHOW_GIFTING_CART,
    SHOW_GIFTING_COUPON_LISTING,
}

export type CheckoutAction =
    | { type: CheckoutActionTypes.SHOW_PAYMENTS; payload?: ShowPaymentsPayload }
    | { type: CheckoutActionTypes.SHOW_CART; payload: CartRendererActionPayload | null }
    | { type: CheckoutActionTypes.SHARED_CART; payload: SharedCartPayload }
    | { type: CheckoutActionTypes.UNLOCK_GROUP_CART; payload: UnlockGroupCartActionPayload }
    | { type: CheckoutActionTypes.SHOW_COUPON_LISTING; payload: CouponListingActionPayload }
    | {
          type: CheckoutActionTypes.PROCESS_ORDER;
          payload: ProcessOrderActionPayload;
      }
    | {
          type: CheckoutActionTypes.CONFIRM_ORDER;
          payload: ConfirmOrderActionPayload | null;
      }
    | {
          type: CheckoutActionTypes.PAYMENT_FAILED;
          payload: FailedOrderActionPayload;
      }
    | {
          type: CheckoutActionTypes.ORDER_INTERRUPTION;
          payload: OrderInterruptionAlertPayload;
      }
    | {
          type: CheckoutActionTypes.WEBVIEW_REFRESH_ORDER_ID_MISMATCH_ALERT;
          payload: WebviewRefreshOrderIdMismatchAlertPayload;
      }
    | {
          type: CheckoutActionTypes.VPA_TIMER;
          payload: VpaTimerActionPayload;
      }
    | {
          type: CheckoutActionTypes.SHOW_FULL_PAGE_LOADER;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.ADD_MONEY_CONFIRM;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.INVALID_COUPON_ALERT;
          payload: InvalidCouponAlertPayload;
      }
    | {
          type: CheckoutActionTypes.DIRECT_PLACE_ORDER;
          payload?: DirectPlaceOrderPayload;
      }
    | {
          type: CheckoutActionTypes.PAYLATER_SIMPL_LINKING_FAILED;
          payload: PayLaterSimplActionFailurePayload;
      }
    | {
          type: CheckoutActionTypes.PAYLATER_SIMPL_LINKING_SUCCESS_DONT_PROCEED_WITH_ORDER;
          payload: PayLaterSimplActionFailurePayload;
      }
    | {
          type: CheckoutActionTypes.PAYLATER_SIMPL_LINKING_SUCCESS_PROCEED_WITH_ORDER;
          payload: PayLaterSimplActionSuccessPayload;
      }
    | {
          type: CheckoutActionTypes.PAYMENT_TXN_STATUS_POLLER;
          payload: UpiIntentPollerActionPayload;
      }
    | {
          type: CheckoutActionTypes.POST_SWIGGY_ADD_MONEY;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.POST_PAYLATER_LINKING;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.SHOW_SWIGGYMONEY_PAYMENTS;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.ADD_NEW_CARD;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.MANAGE_CARD;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.SECURE_CARD;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.PROCESS_TRANSACTION;
          payload: ProcessTransactionActionPayload;
      }
    | {
          type: CheckoutActionTypes.CONFIRM_TRANSACTION;
          payload: ConfirmTransactionActionPayload;
      }
    | {
          type: CheckoutActionTypes.PENNY_TXN_STATUS_POLLER;
          payload: PollPennyTransactionStatusActionPayload;
      }
    | {
          type: CheckoutActionTypes.TRANSACTION_FAILED;
          payload: FailedTransactionActionPayload;
      }
    | {
          type: CheckoutActionTypes.GENERIC_PAYMENT_ALERT;
          payload: PaymentAlertProps;
      }
    | {
          type: CheckoutActionTypes.GENERIC_PAYMENT_TOAST;
          payload: PaymentToastProps;
      }
    | {
          type: CheckoutActionTypes.PAY_ON_DELIVERY_PAYMENT_ALREADY_DONE;
          payload: PayOnDeliveryPaymentAlreadyDoneActionPayload;
      }
    | {
          type: CheckoutActionTypes.AUTOPAY_ELIGIBLE_PAYMENT_FAILED;
          payload: AutoPayFailedOrderActionPayload;
      }
    | {
          type: CheckoutActionTypes.AUTOPAY_ORDER_PROCESS_SUCCESSFUL;
          payload: ConfirmOrderActionPayload;
      }
    | {
          type: CheckoutActionTypes.LINK_WALLET_WITH_NUMBER;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.ADD_MONEY_AND_DELINK_WALLET;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.PAYLATER_LINKING_CONFIRMATION;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.TURBO_PAY;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.TURBO_PLACE_ORDER;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.DINEOUT_PAYMENT_SUCCESS;
          payload?: DineoutSuccessActionPayload;
      }
    | {
          type: CheckoutActionTypes.DINEOUT;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.DINEOUT_BILL_PAYMENT_CART;
          payload?: DineoutCartRendererActionPayload;
      }
    | {
          type: CheckoutActionTypes.DINEOUT_TABLE_RESERVATION_CART;
          payload?: DineoutCartRendererActionPayload;
      }
    | {
          type: CheckoutActionTypes.DINEOUT_DIRECT_PLACE_ORDER;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.SCENES_FULL_PAYMENT;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.STEAL_STORE_CART;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.SHOW_GIFTING_CART;
          payload?: any;
      }
    | {
          type: CheckoutActionTypes.SHOW_GIFTING_COUPON_LISTING;
          payload?: any;
      }
    | {
          type: CheckoutActionTypes.EMI_SELECTION;
          payload?: null;
      }
    | {
          type: CheckoutActionTypes.SHOW_PAYMENT_MODES;
          payload?: null;
      };

export function reducer(state: CheckoutState, action: CheckoutAction): CheckoutState {
    switch (action.type) {
        case CheckoutActionTypes.SHOW_PAYMENTS:
            return { ...state, type: action.type, payload: action?.payload };
        case CheckoutActionTypes.SHARED_CART:
            return { ...state, type: action.type, payload: action?.payload };
        case CheckoutActionTypes.SHOW_GIFTING_CART:
            return { ...state, type: action.type, payload: action?.payload };
        case CheckoutActionTypes.SHOW_FULL_PAGE_LOADER:
        case CheckoutActionTypes.ADD_MONEY_CONFIRM:
        case CheckoutActionTypes.SHOW_SWIGGYMONEY_PAYMENTS:
        case CheckoutActionTypes.POST_SWIGGY_ADD_MONEY:
        case CheckoutActionTypes.ADD_NEW_CARD:
        case CheckoutActionTypes.MANAGE_CARD:
        case CheckoutActionTypes.SECURE_CARD:
        case CheckoutActionTypes.LINK_WALLET_WITH_NUMBER:
        case CheckoutActionTypes.ADD_MONEY_AND_DELINK_WALLET:
        case CheckoutActionTypes.PAYLATER_LINKING_CONFIRMATION:
        case CheckoutActionTypes.TURBO_PAY:
        case CheckoutActionTypes.TURBO_PLACE_ORDER:
        case CheckoutActionTypes.POST_PAYLATER_LINKING:
        case CheckoutActionTypes.DINEOUT_DIRECT_PLACE_ORDER:
            return { ...state, type: action.type, payload: null };
        case CheckoutActionTypes.DINEOUT_TABLE_RESERVATION_CART:
        case CheckoutActionTypes.DINEOUT_BILL_PAYMENT_CART:
            return { ...state, type: action.type, payload: action?.payload };
        case CheckoutActionTypes.SCENES_FULL_PAYMENT:
        case CheckoutActionTypes.STEAL_STORE_CART:
            return { ...state, type: action.type, payload: null };
        case CheckoutActionTypes.DINEOUT:
            return { ...state, type: action.type, payload: null };
        case CheckoutActionTypes.DIRECT_PLACE_ORDER:
            return { ...state, type: action.type, payload: action?.payload };
        case CheckoutActionTypes.PROCESS_ORDER:
        case CheckoutActionTypes.VPA_TIMER:
        case CheckoutActionTypes.PAYMENT_TXN_STATUS_POLLER:
        case CheckoutActionTypes.CONFIRM_ORDER:
        case CheckoutActionTypes.PAYMENT_FAILED:
        case CheckoutActionTypes.ORDER_INTERRUPTION:
        case CheckoutActionTypes.INVALID_COUPON_ALERT:
        case CheckoutActionTypes.PROCESS_TRANSACTION:
        case CheckoutActionTypes.CONFIRM_TRANSACTION:
        case CheckoutActionTypes.PENNY_TXN_STATUS_POLLER:
        case CheckoutActionTypes.TRANSACTION_FAILED:
        case CheckoutActionTypes.GENERIC_PAYMENT_ALERT:
        case CheckoutActionTypes.GENERIC_PAYMENT_TOAST:
        case CheckoutActionTypes.PAY_ON_DELIVERY_PAYMENT_ALREADY_DONE:
        case CheckoutActionTypes.AUTOPAY_ELIGIBLE_PAYMENT_FAILED:
        case CheckoutActionTypes.AUTOPAY_ORDER_PROCESS_SUCCESSFUL:
        case CheckoutActionTypes.PAYLATER_SIMPL_LINKING_FAILED:
        case CheckoutActionTypes.PAYLATER_SIMPL_LINKING_SUCCESS_DONT_PROCEED_WITH_ORDER:
        case CheckoutActionTypes.PAYLATER_SIMPL_LINKING_SUCCESS_PROCEED_WITH_ORDER:
        case CheckoutActionTypes.SHOW_CART:
        case CheckoutActionTypes.SHOW_COUPON_LISTING:
        case CheckoutActionTypes.WEBVIEW_REFRESH_ORDER_ID_MISMATCH_ALERT:
        case CheckoutActionTypes.SHOW_GIFTING_COUPON_LISTING:
            return { ...state, ...action };
        case CheckoutActionTypes.UNLOCK_GROUP_CART:
            return { ...state, type: action.type, payload: action?.payload };
        case CheckoutActionTypes.DINEOUT_PAYMENT_SUCCESS:
            return { ...state, type: action.type, payload: action?.payload };
        case CheckoutActionTypes.SHOW_PAYMENT_MODES:
            return { ...state, type: action.type, payload: null };
        default:
            return state;
    }
}
